// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (-webkit-min-device-pixel-ratio:0){input[data-v-63e5976b],select[data-v-63e5976b],textarea[data-v-63e5976b]{font-size:16px}}.swiper-wrapper[data-v-63e5976b]{margin-left:50px;margin-right:50px}@media only screen and (max-width:767px){.mob-hide[data-v-63e5976b]{display:none}}@media only screen and (min-width:768px){.desktop-hide[data-v-63e5976b]{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
